import { HomeFloor1Icon } from './HomeFloor1Icon';

/**
 * author: GreenTurtwig
 * id B83F1FBD-0D66-4CEE-91FC-640B78AABF4E
 * name home-floor-1
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-1.svg
 * tags
 * - Home Automation 
 */
export const HouseFloor1Icon = HomeFloor1Icon;
export default HouseFloor1Icon